export default __webpack_public_path__ + "static/media/Giulio Xiloyannis.b6ca7a32.png";